<template>
    <hts-slide-over
        :show="show"
        :title="action === 'create' ? $t('labels.supplyDocument.add') : $t('labels.supplyDocument.edit')"
        :submit="onSubmit"
        :rules="rules"
        @close="close">
        <template #body>
            <div class="hts-vehicles-ignore-add-vehicle">
                <div class="hts-vehicles-ignore-add-vehicle__container-body">
                    <div
                        class="grid gap-4 p-4"
                        :class="columnClass">
                        <hts-form-input
                            v-model="dataForm.title"
                            :label="$t('labels.supplyDocument.name')"
                            :color="props.color"
                            required
                            prop="title"
                            name="title" />
                        <hts-form-select
                            v-model="dataForm.type"
                            :label="$t('labels.supplyDocument.type')"
                            :items="optionType"
                            key-id="code"
                            key-label="name"
                            :color="props.color"
                            prop="type"
                            name="type" />
                        <hts-form-select
                            v-model="dataForm.privacy"
                            :label="$t('labels.supplyDocument.view')"
                            :items="optionPrivacy"
                            key-id="code"
                            key-label="name"
                            :color="props.color"
                            prop="privacy"
                            name="privacy" />
                        <hts-form-input
                            v-model="dataForm.description"
                            :label="$t('labels.supplyDocument.description')"
                            :color="props.color"
                            prop="description"
                            name="description" />
                        <hts-form-button
                            icon-name="hi-cloud-arrow-up-icon"
                            icon-position="right"
                            @click="onUploadFile">
                            {{ $t('labels.upload') }}
                        </hts-form-button>
                        <div class="grid gap-4">
                            <div
                                v-for="(item, index) in filesUpload"
                                :key="item.name"
                                class="flex justify-around">
                                <div>
                                    <h3>
                                        {{ item.name }}
                                    </h3>
                                    <p>
                                        {{ (item.size / (1024 * 1024)).toFixed(2) }} mb
                                    </p>
                                </div>
                                <a @click.prevent="filesUpload.splice(index, 1)">
                                    <hi-x-circle-icon class="h-22 w-22" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <input
                ref="uploadImg"
                class="hidden"
                type="file"
                @change="onFileSelected" >
        </template>
    </hts-slide-over>
</template>
<script lang="ts" setup>
import { ISupplyDocument, ESupplyDocumentType, ESupplyDocumentPrivacy } from '../models/supply'
const emits = defineEmits(['close', 'on-submit'])
const props = defineProps({
  show: {
    type: Boolean,
    default: false,
    required: true
  },
  column: {
    type: Number,
    default: 1
  },
  color: {
    type: String,
    default: 'theme'
  },
  documentData: {
    type: Object as () => ISupplyDocument,
    required: true
  },
  action: {
    type: String,
    default: 'create',
    required: true
  }
})

const rules = {
  title: 'required'
}

const optionType = [
  {
    code: ESupplyDocumentType.FUEL,
    name: $t('labels.supplyList.fuel')
  },
  {
    code: ESupplyDocumentType.REPAIR_LARGE,
    name: $t('labels.supplyList.repairLarge')
  },
  {
    code: ESupplyDocumentType.REPAIR_SMALL,
    name: $t('labels.supplyList.repairSmall')
  },
  {
    code: ESupplyDocumentType.ASSETS_LARGE,
    name: $t('labels.supplyList.assetsLagre')
  },
  {
    code: ESupplyDocumentType.ASSETS_SMALL,
    name: $t('labels.supplyList.assetsSmall')
  }
]

const optionPrivacy = [
  {
    code: ESupplyDocumentPrivacy.PRIVACY,
    name: $t('labels.supplyDocument.privacy')
  },
  {
    code: ESupplyDocumentPrivacy.ALL,
    name: $t('labels.supplyDocument.all')
  },
  {
    code: ESupplyDocumentPrivacy.ONLYME,
    name: $t('labels.supplyDocument.onlyMe')
  }
]

const uploadImg = ref<HTMLElement>()
const filesUpload = ref<File[]>([])

const dataForm: ISupplyDocument = reactive({ ...props.documentData })

const show = computed(() => {
  return props.show
})
const action = computed(() => {
  return props.action
})

const cleanData = (data: any) => {
  const temp = data
  if (action.value === 'create') {
    delete temp.ID
  }
  temp.document = filesUpload.value
  for (const propName in temp) {
    if (temp[propName] === '') {
      delete temp[propName]
    }
  }
  temp.document = filesUpload.value
  return temp
}
const onSubmit = () => {
  const data = cleanData(dataForm)
  emits('on-submit', data, props.action)
}

const close = () => {
  emits('close')
}

const onUploadFile = () => {
  uploadImg.value?.click()
}

const onFileSelected = (event: Event) => {
  const target = event.target as HTMLInputElement
  if (target.files && target.files.length > 0) {
    filesUpload.value = [...target.files]
  }
}

const columnClass = computed(() => {
  if ($lodash.inRange(props.column, 1, 12)) {
    return `grid-cols-${props.column}`
  }

  return 'grid-cols-1'
})
</script>
